<div class="selector">
	<osapp-selector displayMode="tags" [options]="typeOptions" scrollWrapper="false"
		(selectionChanged)="onSelectedTypeChanged($event)">
	</osapp-selector>
</div>

<idl-surveillances-list [params]="params" [filterPrefix]="selectedType"></idl-surveillances-list>